import PatientListList from '../PatientListList'
import PatientListDetail from '../PatientListDetail'
import PatientListSelect from '../PatientListSelect'
import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'patient-list',
  data: function () {
    return {
      patientName: '',
      facilityId: null,
      facilityName: '',
      clinicId: null,
      clinicName: '',
      careOfficeId: null,
      careOfficeName: '',
      shopId: null,
      patientId: null,
      word50: null,
      isEnableFlag: false,
      utils: utils,
      searchCallbackFlag: false,
      watchScroll: null,
      // ソート
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'patient_name_furigana':             {'state': true,  'order': true },
        'sex':                               {'state': false, 'order': false},
        'birthday':                          {'state': false, 'order': false},
        'age':                               {'state': false, 'order': false},
        'v_facility.facility_name_furigana': {'state': false, 'order': false},
      },
      sortStateInit: {}
    }
  },
  components: {
    PatientListList,
    PatientListDetail,
    PatientListSelect
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.patientSearchParams !== null) {
        this.$store.getters.patientSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.patientSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.autocompleteEventRemove({$: $, elem:'#facility_name_autocomplete'}) // オートコンプリートイベント削除
    utils.autocompleteEventRemove({$: $, elem:'#clinic_name_autocomplete'}) // オートコンプリートイベント削除
    utils.autocompleteEventRemove({$: $, elem:'#careoffice_name_autocomplete'}) // オートコンプリートイベント削除
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  created: function () {
    var readMore = false
    if (utils.isBlank(this.$router.currentRoute.query.type)) {
      var ssShopID = window.sessionStorage.getItem('pal-shopID')
      var ssFacilityName = window.sessionStorage.getItem('pal-facilityName')
      var ssClinicName = window.sessionStorage.getItem('pal-clinicName')
      var ssCareOfficeName = window.sessionStorage.getItem('pal-careOfficeName')
      var ssPatientName = window.sessionStorage.getItem('pal-patientName')
      var ssIsEnableFlag = window.sessionStorage.getItem('pal-isEnableFlag')
      var ssSortKey = window.sessionStorage.getItem('pal-sortKey')
      var ssSortStateOrder = window.sessionStorage.getItem('pal-sortStateOrder')
      if (!!ssShopID) {
        if (ssShopID === 'null') {
          this.shopId = null
        } else {
          this.shopId = ssShopID
        }
      } else {
        this.shopId = this.$store.getters.currentShopId
      }
      if (!!ssFacilityName) {
        this.facilityName = ssFacilityName
      }
      if (!!ssClinicName) {
        this.clinicName = ssClinicName
      }
      if (!!ssCareOfficeName) {
        this.careOfficeName = ssCareOfficeName
      }
      if (!!ssPatientName) {
        this.patientName = ssPatientName
      }
      if (!!ssIsEnableFlag) {
        this.isEnableFlag = Boolean(ssIsEnableFlag)
      }
      if (!!ssSortKey) {
        var key = ssSortKey
        this.sortKey = key
        if (ssSortStateOrder != null) {
          if (ssSortStateOrder === "true") {
            this.sortStateOrder = true
          } else {
            this.sortStateOrder = false
          }
        } else {
          this.sortStateOrder = !this.sortState[key].order
        }
        for (var k in this.sortState) {
          this.sortState[k].state = false
          if (k !== key) {
            this.sortState[k].order = false
          }
        }
        this.sortState[key].state = true
        this.sortState[key].order = this.sortStateOrder
      }

      // ソート初期化用保存
      for (var k in this.sortState) {
        this.sortStateInit[k] = {}
        this.sortStateInit[k].state = this.sortState[k].state
        this.sortStateInit[k].order = this.sortState[k].order
      }
    } else {
      this.shopId = this.$store.getters.currentShopId
    }

    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})



    if (this._self.isCreateReport) {
      // 報告書作成
      this.searchList(readMore)
      // 最下部スクロール検索イベント
      utils.scrollBottomSearchEvent(this.searchList, true, 'button.next-page-search-btn')
    } else {
      // 患者検索
      this.search(readMore)
      // オートコンプリートイベント
      utils.autocompleteEvent({$: $, elem: '#facility_name_autocomplete',   search: this.search, searchParams: false, searchAutocomplete: this.getFacilities,  setSearchData: this.setSearchFacility,   clear: this.clearFacilities,});
      utils.autocompleteEvent({$: $, elem: '#clinic_name_autocomplete',     search: this.search, searchParams: false, searchAutocomplete: this.getClinics,     setSearchData: this.setSearchClinic,     clear: this.clearClinics,});
      utils.autocompleteEvent({$: $, elem: '#careoffice_name_autocomplete', search: this.search, searchParams: false, searchAutocomplete: this.getCareOffices, setSearchData: this.setSearchCareOffice, clear: this.clearCareOffices,});
      // 最下部スクロール検索イベント
      utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
    }
  },
  mounted () {
    if (!this._self.isCreateReport) {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
  },
  computed: {
    patients () {
      return this.$store.getters.patients
    },
    patientsDataExists () {
      return this.$store.getters.patientsDataExists
    },
    facilities () {
      return this.$store.getters.facilitiesAutocomplete
    },
    careOffices () {
      return this.$store.getters.careOfficesAutocomplete
    },
    clinics () {
      return this.$store.getters.clinicsAutocomplete
    },
    shops () {
      return this.$store.getters.shops
    },
    nextPage () {
      return this.$store.getters.patientsNextPage
    },
    currentPage () {
      return this.$store.getters.patientsCurrentPage
    },
    canManage () {
      return this.$store.getters.canManage
    },
    isList () {
      return this.$route.params.type === 'list'
    },
    isDetail () {
      return this.$route.params.type === 'detail'
    },
    isSelect () {
      return this.$route.params.type === 'select'
    },
    /** 報告作成判定 */
    isCreateReport() {
      return this.$router.currentRoute.query.type === 'create_report'
    },
    totalCount () {
      return this.$store.getters.patientsTotalCount
    },
    isFacility () {
      return this.$store.getters.isFacility
    },
    isCareOffice () {
      return this.$store.getters.isCareOffice
    },
    isClinic () {
      return this.$store.getters.isClinic
    },
    uploadCounter () {
      return this.$store.getters.avatarUploadCounter
    },
    uploadErrors () {
      return this.$store.getters.avatarUploadErrors
    },
    uploadSuccess () {
      return this.$store.getters.avatarUploadStatus === 'success'
    },
    /** 通知 */
    notify () {
      return this.$store.getters.reportEditNotify
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  methods: {
    /** 患者検索 */
    search: function (readMore) {
      var url = null
      var clear = true
      var loadparams = true
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.patientSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.patientSearchParams['scrollHeight']
        this.$store.getters.patientSearchParams['pageYOffset'] = null
        this.$store.getters.patientSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.patientsNextPage
        clear = false
        loadparams = 'block'
      } else {
        // 通常検索
        this.searchCallbackFlag = false
      }
      this.autoCompleteClear({})

      var data = {
        'user_id':          this.$store.getters.userId,
        'patient_name':     this.patientName,
        'facility_id':      this.facilityId,
        'facility_name':    this.facilityName,
        'clinic_id':        this.clinicId,
        'clinic_name':      this.clinicName,
        'care_office_id':   this.careOfficeId,
        'careoffice_name':  this.careOfficeName,
        'shop_id':          this.shopId,
        'order':            this.orderByString()
      }
      // 取引中止先
      if (this.isEnableFlag) {
        data['enable_flag'] = constant.enable_flag.off // 停止
      } else {
        data['enable_flag'] = constant.enable_flag.on  // 有効
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }
      if (utils.isBlank(this.$router.currentRoute.query.type)) {
        window.sessionStorage.setItem("pal-shopID", this.shopId)
        if (!!this.facilityName) {
          window.sessionStorage.setItem('pal-facilityName', this.facilityName)
        } else {
          window.sessionStorage.removeItem('pal-facilityName')
        }
        if (!!this.facilityName) {
          window.sessionStorage.setItem('pal-facilityName', this.facilityName)
        } else {
          window.sessionStorage.removeItem('pal-facilityName')
        }
        if (!!this.clinicName) {
          window.sessionStorage.setItem('pal-clinicName', this.clinicName)
        } else {
          window.sessionStorage.removeItem('pal-clinicName')
        }
        if (!!this.careOfficeName) {
          window.sessionStorage.setItem('pal-careOfficeName', this.careOfficeName)
        } else {
          window.sessionStorage.removeItem('pal-careOfficeName')
        }
        if (!!this.patientName) {
          window.sessionStorage.setItem('pal-patientName', this.patientName)
        } else {
          window.sessionStorage.removeItem('pal-patientName')
        }
        if (!!this.isEnableFlag) {
          window.sessionStorage.setItem('pal-isEnableFlag', this.isEnableFlag)
        } else {
          window.sessionStorage.removeItem('pal-isEnableFlag')
        }
        if (!!this.sortKey) {
          window.sessionStorage.setItem("pal-sortKey", this.sortKey)
        } else {
          window.sessionStorage.removeItem("pal-sortKey")
        }
        if (this.sortStateOrder !== "") {
          window.sessionStorage.setItem("pal-sortStateOrder", this.sortStateOrder)
        } else {
          window.sessionStorage.removeItem("pal-sortStateOrder")
        }
      }

      this.$store.dispatch('PATIENT_SEARCH_LIST_ENABLE', {url: url, clear: clear, data: data, loadparams: loadparams, callback: callback})
      return false
    },
    /** 報告書作成 */
    searchList: function (readMore) {
      var url = null
      var clear = true
      var loadparams = true
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear = false
        loadparams = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.patientSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.patientSearchParams['scrollHeight']
        this.$store.getters.patientSearchParams['pageYOffset'] = null
        this.$store.getters.patientSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.patientsNextPage
        clear = false
        loadparams = 'block'
      } else {
        // 再検索
        this.searchCallbackFlag = false
      }
      this.autoCompleteClear({})

      if (this._self.isCreateReport) {
        // 報告書作成
        this.facilityId = this.getQuerystringParams('facilityId')
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'user_id':              this.$store.getters.userId,
        'type':                 this.$router.currentRoute.query.type,
        'patient_name':         this.patientName,
        'facility_id':          this.facilityId,
        'shop_id':              this.shopId,
        'word50':               this.word50,
        'order':                this.orderByString()
        // 'enable_flag':          constant.enable_flag.on, // 有効 // ※前画面で選択しているので含めない
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      this.$store.dispatch('PATIENT_SEARCH_LIST', {url: url, clear: clear, data: data, loadparams: loadparams, callback: callback})
    },
    /** 50音検索 */
    searchWord50: function (key) {
      this.word50 = key
      this.searchList(false, {'word50': this.word50})
    },
    getFacilities: function () {
      this.facilityId = null
      this.$store.dispatch('FACILITY_SEARCH', {data: {'facility_name': this.facilityName, 'shop_id': this.shopId}, autocomplete: true})
    },
    clearFacilities: function () {
      this.autoCompleteClear({facility: 500})
    },
    setSearchFacility: function (facilityId, facilityName) {
      this.facilityId = facilityId
      this.facilityName = facilityName
      this.autoCompleteClear({facility: 0})
    },
    getCareOffices: function () {
      this.careOfficeId = null
      this.$store.dispatch('CARE_OFFICE_SEARCH', {data: {'careoffice_name': this.careOfficeName, 'shop_id': this.shopId}, autocomplete: true})
    },
    clearCareOffices: function () {
      this.autoCompleteClear({care_office: 500})
    },
    setSearchCareOffice: function (careOfficeId, careOfficeName) {
      this.careOfficeId = careOfficeId
      this.careOfficeName = careOfficeName
      this.autoCompleteClear({care_office: 0})
    },
    getClinics: function () {
      this.clinicId = null
      this.$store.dispatch('CLINIC_SEARCH', {data: {'clinic_name': this.clinicName, 'shop_id': this.shopId}, autocomplete: true})
    },
    clearClinics: function () {
      this.autoCompleteClear({clinic: 500})
    },
    setSearchClinic: function (clinicId, clinicName) {
      this.clinicId = clinicId
      this.clinicName = clinicName
      this.autoCompleteClear({clinic: 0})
    },
    /** オートコンプリートクリア */
    autoCompleteClear: function (param) {
      var time = Object.assign({}, {facility: 100, care_office: 100, clinic: 100}, param)
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR',    time.facility)
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', time.care_office)
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR',      time.clinic)
    },
    goNext: function() {
      if (this.$router.currentRoute.query.type === 'create_report') {
        //TODO
        this.$router.push({ path: '/nsips/reports/' + this.getQuerystringParams('facilityId') + '/edit'})
      }
    },
    goPrev: function() {
      if (this.$router.currentRoute.query.type === 'create_report') {
        this.$router.push({ path: '/facilities', query: {type: this.$router.currentRoute.query.type, 'keep': 'true'}})
      } else {
        this.$router.push({ path: '/'})
      }
    },
    goOutPatientList: function () {
      this.$router.push({ path: '/outpatients/list', query: { type: this.$router.currentRoute.query.type } })
    },
    goPatientList: function () {
      this.$router.push({ path: '/patients/list', query: { type: this.$router.currentRoute.query.type } })
    },

    /** 計画書作成 */
    goPlansCreate: function() {
      this.$router.push({ path: '/plans/create', query: {from: 'list'} })
    },
    getShops: function () {
      // this.$store.dispatch('SHOP_SEARCH')
      this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    },
    onDragOver: function (event) {
      console.log('onDragOver')
      event.preventDefault()
    },
    onDrop: function (event) {
      console.log('onDrop')
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault()

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.dataTransfer.files
      this.upload(files)
    },
    onFileChange: function (event) {
      console.log('onFileChange')

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files
      this.upload(files)
    },
    uploadStart (patientId) {
      this.patientId = patientId
      this.$store.dispatch('PATIENT_UPLOAD_START')
    },
    upload: function (files) {
      // 一件アップロード
      var formData = new FormData()
      formData.append('patient[avartar]', files[0])

      this.$store.dispatch('PATIENT_UPDATE', {patientId: this.patientId, data: formData})
    },
    clearSearchParams: function() {
      this.autoCompleteClear({})
      if (this.$store.getters.canManage && this.shopId === null) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.facilityId     = null
      this.facilityName   = ''
      this.clinicId       = null
      this.clinicName     = ''
      this.careOfficeId   = null
      this.careOfficeName = ''
      this.PatientName    = ''
      this.word50         = null
      this.isEnableFlag   = false
      this.$store.dispatch('PATIENT_CLEAR')
    },

    /** 全患者選択 クリア */
    selectAll: function (checked) {
      var elm = document.querySelectorAll('input.patient-checkbox')
      document.querySelector('input.patient-checkbox-all').checked = checked
      Array.prototype.map.apply(elm, [function (e) {
        e.checked = checked
      }])
      var data = {
        type:        'facility',
        sel_flag:    checked ? 1 : 0,
        facility_id: this.$router.currentRoute.params['facilityId'],
        user_id:     this.$store.getters.userId
      }
      this.updateSelFlag(data)
    },
    /** 選択状態更新 */
    updateSelFlag: function (selFlagArr) {
      var self = this
      var callback = function () {
        self.searchList('sort')
      }
      this.$store.dispatch('PATIENT_SET_SEL_FLAG', {data: selFlagArr, callback: callback})
    },

    /** url クエリーストリングパラメーターを取得 */
    getQuerystringParams: function (key) {
      return this.$router.currentRoute.params[key]
    },
    /** ソート実行 */
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      // 初期化
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      // 矢印変更
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order
      // 検索
      if (this._self.isCreateReport) {
        // 報告書作成
        this.searchList('sort')
      } else {
        // 患者検索
        this.search('sort')
      }
    },
    /** ソート矢印 */
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          if (key === 'age') {
            key = 'birthday' // 年齢は生年月日
            asc_desc = asc_desc === 'asc' ? 'desc' : 'asc' // 年齢は逆
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('patient_name_furigana asc')
      }
      return result.join(' , ')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/patient-list.js